import React from 'react';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import ExtraCurricular from './components/ExtraCurricular';
import Contact from './components/Contact';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <Box sx={{ backgroundColor: 'background.default' }}>
        <Navbar />
        <Hero />
        <About />
        <Portfolio />
        <ExtraCurricular />
        <Contact />
      </Box>
    </ThemeProvider>
  );
}

export default App;
